import Vue from "vue";
import Vuetify from "vuetify";
import colorVariables from '../styles/_color-variables.scss'
import "vuetify/dist/vuetify.min.css";
import VueI18n from "vue-i18n";
import loadLocaleMessages from "../helperFunctions/LoadLocaleMessages";

Vue.use(Vuetify);
Vue.use(VueI18n);

export const i18n = new VueI18n({
    locale: "en",
    messages: loadLocaleMessages()
});

const opt = {
    lang: {
        t: (key, ...params) => i18n.t(key, params),
    },
    icons: {
        iconfont: "mdi",
    },
    theme: {
        dark: false,
        themes: {
            dark: true,
            light: {
                primary: colorVariables.primary,
                secondary: colorVariables.secondary,
                accent: colorVariables.accent,
                error: colorVariables.error,
                info: colorVariables.info,
                success: colorVariables.success,
                warning: colorVariables.warning,
                adminPrimary: colorVariables.adminPrimary
            },
            dark: {
                primary: colorVariables.primary,
                secondary: colorVariables.secondary,
                accent: colorVariables.accent,
                error: colorVariables.error,
                info: colorVariables.info,
                success: colorVariables.success,
                warning: colorVariables.warning,
                adminPrimary: colorVariables.adminPrimary
            }
        }
    }
};

const vuetify = new Vuetify(opt);

export default vuetify;
